// src/shared/constants/routes.ts

export const ROUTES = {
  // Main routes
  LOGIN: '/',
  HUB: '/hub',
  
  // Quality Management routes
  QUALITY_MANAGEMENT: {
    BASE: '/quality-management',
    PM_DASHBOARD: '/quality-management/pm-dashboard',
    EMPLOYEE_DASHBOARD: '/quality-management/employee-dashboard',
    TEAM_CALENDAR: '/quality-management/team-calendar',
    OVERTIME_APPROVALS: '/quality-management/overtime-approvals',
    DELIVERY_PLAN: '/quality-management/delivery-plan',
    ANALYTICS_DASHBOARD: '/quality-management/analytics-dashboard',
    ADMIN: '/quality-management/admin',
    // Padrão da rota (para <Route path>) e helper de navegação
    PROJECT_DETAIL: '/quality-management/project/:projectId',
    PROJECT: (projectId: string | number) => `/quality-management/project/${projectId}`,
  },
  
  // Quality People routes
  QUALITY_PEOPLE: {
    BASE: '/quality-people',
    DASHBOARD: '/quality-people/dashboard',
    INDIVIDUAL: '/quality-people/individual',
    DEPARTMENT: '/quality-people/department',
  },
  
  // Quality NFe routes
  QUALITY_NFE: {
    BASE: '/quality-nfe',
    DASHBOARD: '/quality-nfe/dashboard',
  },
  
  // Future service routes
  QUALITY_HOURS: {
    BASE: '/quality-hours',
    DASHBOARD: '/quality-hours/dashboard',
  },
} as const;

export const QUALITY_SERVICES = [
  {
    id: 'management',
    title: 'Quality Management',
    description: 'Project management application for tracking tasks, time entries, and team collaboration.',
    icon: '📊',
    isAvailable: true,
    route: ROUTES.QUALITY_MANAGEMENT.BASE,
    module: 'quality-management'
  },
  {
    id: 'people',
    title: 'Quality People',
    description: 'Employee evaluation system for managers to assess team performance across different areas.',
    icon: '👥',
    isAvailable: true,
    route: ROUTES.QUALITY_PEOPLE.BASE,
    module: 'quality-people'
  },
  {
    id: 'hours',
    title: 'Quality Hours',
    description: 'Extra hours tracking system for managers to register employee overtime and additional work.',
    icon: '⏰',
    isAvailable: false,
    module: 'quality-hours'
  },
  {
    id: 'nfe',
    title: 'Quality NFe-s',
    description: 'Tax notes submission platform for employees to upload monthly receipts and documentation.',
    icon: '📋',
    isAvailable: true,
    route: ROUTES.QUALITY_NFE.BASE,
    module: 'quality-nfe'
  },
  {
    id: 'support',
    title: 'Support Portal',
    description: 'Access technical support, submit tickets, and get help with Quality services.',
    icon: '🎧',
    isAvailable: true,
    route: 'https://suporte.qualityeng.com.br/',
    module: 'external-support',
    isExternal: true
  },
  {
    id: 'devops',
    title: 'Azure DevOps',
    description: 'Development collaboration platform for code repositories, pipelines, and project management.',
    icon: '⚙️',
    isAvailable: true,
    route: 'https://dev.azure.com/',
    module: 'external-devops',
    isExternal: true
  },
  {
    id: 'inventory',
    title: 'Quality Inventory',
    description: '',
    icon: '📦',
    isAvailable: false,
    module: 'quality-inventory'
  },
  {
    id: 'validation',
    title: 'Quality Validation',
    description: '',
    icon: '✅',
    isAvailable: false,
    module: 'quality-validation'
  },
  {
    id: 'dms',
    title: 'Quality DMS',
    description: '',
    icon: '📁',
    isAvailable: false,
    module: 'quality-dms'
  },
  {
    id: 'vod',
    title: 'Quality VOD',
    description: '',
    icon: '🎬',
    isAvailable: false,
    module: 'quality-vod'
  },
  {
    id: 'access',
    title: 'Quality Access',
    description: '',
    icon: '',
    isAvailable: false,
    module: 'quality-access'
  }
] as const;
